import { useEffect, useState } from 'react';
import styles from './ProviderBalance.module.css';
import { getAllProvidersBalanceService } from '../../services/getProvidersBalance.service';
import { Loading } from '../Loading';

const ProviderBalance = () => {
    const [providersBalance, setProvidersBalance] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const response = await getAllProvidersBalanceService.getAllProvidersBalance();
                setProvidersBalance(response.balances);
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        })();
    }, []);

    const formatBalance = (balance: number): string => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(balance);
    };

    if (loading) {
        return (
            <div className={styles.main}>
                <div className={styles.loadingContainer}>
                    <Loading
                        type="spinner"
                        size="large"
                        text="Loading provider balances..."
                        fullScreen
                    />
                </div>
            </div>
        );
    }

    return (
        <main className={styles.main}>
            <div className={styles.header}>
                <h1 className={styles.title}>Provider Balances</h1>
                <p className={styles.subtitle}>View all provider account balances</p>
            </div>
            
            <div className={styles.grid}>
                {providersBalance?.map((provider: any) => (
                    <div className={styles.providerCard} key={provider.providerName}>
                        <div className={styles.cardHeader}>
                            <h3 className={styles.providerName}>{provider.providerName}</h3>
                            <span className={`${styles.status} ${provider.success ? styles.statusSuccess : styles.statusError}`}>
                                {provider.success ? 'Active' : 'Error'}
                            </span>
                        </div>
                        
                        <div className={styles.balanceSection}>
                            <span className={styles.balanceLabel}>Balance</span>
                            <span className={styles.balanceAmount}>
                                {formatBalance(provider.balance)}
                            </span>
                        </div>
                        
                        {provider.message && (
                            <div className={styles.messageSection}>
                                <span className={styles.message}>{provider.message}</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </main>
    );
};

export default ProviderBalance;
